module.exports = __webpack_public_path__ + "static/media/lab-coat.65c3884b.svg";